export const DEFAULT_LOCALE = "en"

export const BUNDLES = {
  en: {
    show_answer: "Show answer",
    got_it: "Got it",
    again: "Again",
    check: "Check",
    next: "Next",
    finish: "Finish",
    progress: "{current} of {total}",
    card_announced: "Card {current} of {total}",
    question_announced: "Question {current} of {total}",
    answer_label: "Answer",
    respell_label: "Say it like",
    note_label: "Note",
    variant_label: "Variant",
    explanation_label: "Why",
    correct: "Correct",
    incorrect: "Not quite",
    correct_answer_is: "The answer is {answer}",
    choose_an_option: "Choose an option first",
    finished_vocab: "Finished — {correct} of {total} recalled",
    finished_quiz: "Finished — {correct} of {total} correct",
    requeued: "You will see this one again",
    unavailable: "This exercise is not available.",
    summary_heading: "All done"
  },
  es: {
    show_answer: "Ver respuesta",
    got_it: "Lo sabía",
    again: "Otra vez",
    check: "Comprobar",
    next: "Siguiente",
    finish: "Terminar",
    progress: "{current} de {total}",
    card_announced: "Tarjeta {current} de {total}",
    question_announced: "Pregunta {current} de {total}",
    answer_label: "Respuesta",
    respell_label: "Se pronuncia",
    note_label: "Nota",
    variant_label: "Variante",
    explanation_label: "Por qué",
    correct: "Correcto",
    incorrect: "Casi",
    correct_answer_is: "La respuesta es {answer}",
    choose_an_option: "Elige una opción primero",
    finished_vocab: "Listo — recordaste {correct} de {total}",
    finished_quiz: "Listo — {correct} de {total} correctas",
    requeued: "Volverás a ver esta",
    unavailable: "Este ejercicio no está disponible.",
    summary_heading: "Terminado"
  }
}

export const SUPPORTED_LOCALES = Object.keys(BUNDLES)

export function normaliseLocale(locale) {
  if (typeof locale !== "string" || !locale) return DEFAULT_LOCALE
  const base = locale.toLowerCase().split(/[-_]/)[0]
  return Object.prototype.hasOwnProperty.call(BUNDLES, base) ? base : DEFAULT_LOCALE
}

export function interpolate(template, vars) {
  if (!vars) return template
  return template.replace(/\{(\w+)\}/g, (match, key) => {
    const value = vars[key]
    return value === null || value === undefined ? match : String(value)
  })
}

export function translator(locale) {
  const resolved = normaliseLocale(locale)
  const bundle = BUNDLES[resolved]
  const fallback = BUNDLES[DEFAULT_LOCALE]

  const t = (key, vars) => {
    const template = bundle[key] !== undefined ? bundle[key] : fallback[key]
    if (template === undefined) return key
    return interpolate(template, vars)
  }

  t.locale = resolved
  return t
}
